var React = require('react');

function SearchInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"f0","d":"M29.394 26.464l-6.428-6.429-.031.031a11.432 11.432 0 002.066-6.566c0-6.351-5.148-11.5-11.5-11.5-6.35 0-11.5 5.149-11.5 11.5S7.151 25 13.501 25a11.45 11.45 0 006.566-2.066l-.031.031 6.429 6.428c.403.405.935.607 1.465.607s1.06-.202 1.464-.607a2.07 2.07 0 000-2.929m-15.893-4.463c-4.687 0-8.5-3.813-8.5-8.5S8.814 5 13.501 5c4.688 0 8.5 3.813 8.5 8.5s-3.813 8.501-8.5 8.501","fill":"#231F20"}));
}

SearchInline.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = SearchInline;

SearchInline.default = SearchInline;
